import { render, staticRenderFns } from "./StudentSupportStatus.vue?vue&type=template&id=f873fbea&scoped=true&"
import script from "./StudentSupportStatus.vue?vue&type=script&lang=js&"
export * from "./StudentSupportStatus.vue?vue&type=script&lang=js&"
import style0 from "./StudentSupportStatus.vue?vue&type=style&index=0&id=f873fbea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f873fbea",
  null
  
)

export default component.exports